import React from 'react';

const NotFound = () => {
   return (
      <div>

         <h1>Page not found</h1>
         <h2> 404 :Something Wrong</h2>   
      </div>
   );
};

export default NotFound;